<template>
  <Transition name="slide-fade">
    <template v-if="!accessedMemberInfo.name && !isImageMode">
      <div v-if="showPanel.isLeftPanel" class="login_panel">
        <div
          class="login_box_wrap"
          :class="{'opacity': disabledQualification()}"
        >
          <img
            class="logo" src="@/assets/images/ContecLogo.png"
            alt="Contec_Logo"
          >
          <img
            class="side_logo" src="@/assets/images/SideLogo.png"
            alt="side logo"
          >
          <LoginBox />
          <IconButtons />
        </div>
      </div>
    </template>
  </Transition>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';

import LoginBox from '@/components/common/LoginBox.vue';
import IconButtons from '@/components/desktop/IconButtons.vue';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';

const { isImageMode } = storeToRefs(useCommonStore());
const { disabledQualification, showPanel } = useCommonStore();
const { accessedMemberInfo } = useMemberStore();
</script>

<style scoped lang="scss">
.login_panel {
  width: 20%;
  height: 100%;
  background: linear-gradient(to right, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.6) 40%, rgba(0, 0, 0, 0) 100%);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;

  .login_box_wrap {
    width: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 100%;
    text-align: center;
    transition: opacity 0.4s ease;
    position: relative;

    &.opacity {
      opacity: 0.3;
    }

    .logo {
      width: 80px;
      position: absolute;
      top: 31px;
      left: 50%;
      transform: translateX(-50%);
    }

    .side_logo {
      width: 256px;
      margin-bottom: 63px;
    }
  }
}
</style>
